import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useStock(filters = {}) {
  const params = {
    page: filters.page || 1,
    limit: filters.limit || 25
  };
  if (filters.q) params.q = filters.q;
  if (filters.warehouseId) params.warehouseId = filters.warehouseId;
  if (filters.categoryId) params.categoryId = filters.categoryId;
  if (typeof filters.lowStock === 'boolean') params.lowStock = filters.lowStock;

  return useQuery({
    queryKey: ['inventory', 'stock', params],
    queryFn: async () => {
      const { data } = await api.get('/catalog/products', { params });
      return {
        items: data?.items || [],
        total: data?.total || 0,
        page: data?.page || 1,
        pages: data?.pages || 1,
        limit: data?.limit || 25
      };
    },
    keepPreviousData: true,
    staleTime: 15_000
  });
}

export function useLowStockReport() {
  return useQuery({
    queryKey: ['reports', 'low-stock'],
    queryFn: async () => {
      const { data } = await api.get('/reports/low-stock');
      return data;
    },
    staleTime: 30_000
  });
}

export function useInventoryValueReport() {
  return useQuery({
    queryKey: ['reports', 'inventory', 'value'],
    queryFn: async () => {
      const { data } = await api.get('/reports/inventory/value');
      return data;
    },
    staleTime: 60_000
  });
}
